package io.github.kingsword09.symbolcraft.symbols.icons.svgl.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.svgl.Icons

public val Icons.WindowsSvgl: ImageVector
    get() {
        if (_windowsSvgl != null) {
            return _windowsSvgl!!
        }
        _windowsSvgl = Builder(name = "WindowsSvgl", defaultWidth = 88.0.dp, defaultHeight = 88.0.dp, viewportWidth = 88.0f, viewportHeight = 88.0f).apply {
            path(fill = SolidColor(Color(0xFF00adef)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(0.0f, 12.40f)
                lineToRelative(35.69f, -4.86f)
                lineToRelative(0.02f, 34.42f)
                lineToRelative(-35.67f, 0.20f)
                close()
                moveTo(35.67f, 45.93f)
                lineTo(35.70f, 80.38f)
                lineTo(0.03f, 75.48f)
                lineTo(0.03f, 45.7f)
                close()
                moveTo(40.00f, 6.91f)
                lineTo(87.31f, 0.0f)
                verticalLineToRelative(41.53f)
                lineToRelative(-47.32f, 0.38f)
                close()
                moveTo(87.33f, 46.26f)
                lineTo(87.31f, 87.60f)
                lineTo(40.00f, 80.92f)
                lineTo(39.93f, 46.18f)
                close()
            }
        }
        .build()
        return _windowsSvgl!!
    }

private var _windowsSvgl: ImageVector? = null
